import React, { useEffect, useState } from "react";
import {
  Box,
  Alert,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Divider,
  Grid,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  getListFinanciadores,
  integraBoton,
} from "../../../services/MyPatientsServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormHelperText from "@mui/material/FormHelperText";
import { useTheme } from "@mui/material/styles";
import listSexo from "../../../constants/sexo";
import listTipoDocumento from "../../../constants/tipoDocumento";
import { enqueueSnackbar } from "notistack";
import { getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

export const FormPrescription = (props) => {
  const theme = useTheme();
  /* const navigate = useNavigate(); */
  const { action } = props;
  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const {idMedico} = data;

  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [listFinanciadores, setListFinanciadores] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchFinanciadores = async () => {
      try {
        const financiadoresData = await getListFinanciadores();
        setListFinanciadores(financiadoresData.results);
      } catch (error) {
        console.error("Error al obtener la lista de financiadores:", error);
      }
    };

    fetchFinanciadores();
  }, []);

  const formik = useFormik({
    initialValues: {
      idMedico,
      nombre: "",
      apellido: "",
      tipoDocumento: "",
      nroDocumento: "",
      fechaNacimiento: "",
      email: "",
      telefono: "",
      sexo: "",
      nombreFinanciador: "",
      nroFinanciador: "",
      nroAfiliado: "",
      plan: "",
      action: action,
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required("El nombre es requerido"),
      apellido: Yup.string().required("El apellido es requerido"),
      tipoDocumento: Yup.string().required("El tipo de documento es requerido"),
      nroDocumento: Yup.string()
        .max(12, "El número de documento debe contener máximo 12 dígitos")
        .required("El número de documento es requerido")
        .matches(
          /^[0-9]+$/,
          "El número de documento debe contener solo números"
        ),
      fechaNacimiento: Yup.string()
        .required("La fecha de nacimiento es requerida")
        .test(
          "is-before-today",
          "La fecha de nacimiento debe ser anterior al día de hoy",
          (value) => {
            const selectedDate = new Date(value);
            const today = new Date();
            return selectedDate < today;
          }
        ),
      email: Yup.string()
        .email("Ingrese un correo electrónico válido")
        .required("El correo electrónico es requerido")
        .max(100, "El campo Email puede tener hasta 100 caracteres"),
      telefono: Yup.string().when("action", {
        is: (val) => val === "update",
        then: Yup.string()
          .required("El teléfono es requerido")
          .matches(/^[0-9]+$/, "El teléfono debe contener sólo números"),
        otherwise: Yup.string()
          .notRequired()
          .matches(/^[0-9]+$/, "El teléfono debe contener sólo números"),
      }),
      sexo: Yup.string().required("El sexo es requerido"),
      nroFinanciador: Yup.string().required("El financiador es requerido"),
      plan: Yup.string().required("El plan es requerido"),
      nroAfiliado: Yup.string()
        .max(25, "El nro de afiliado debe contener máximo 25 dígitos")
        .required("El nro de afiliado es requerido")
        .matches(/^[0-9]+$/, "El nro de afiliado debe contener sólo números"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const res = await handleGenerarReceta(values);
        if (res === "Ok") {
          setErrorMessage("");
          formik.resetForm();
        } else {
          setErrorMessage(res);
        }
      } catch (error) {
        //console.error("Error al enviar el formulario:", error);
        setErrorMessage("Error al enviar el formulario");
      } finally {
        //formik.resetForm();
        setLoading(false);
      }
    },
  });

  const validateNroAfiliado = (value) => {
    let errorMessage = "";
    if (!/^[a-zA-Z0-9]*$/.test(value)) {
      errorMessage = "El Nro de Afiliado debe ser alfanumérico";
    }
    return errorMessage;
  };

  const formatDateForInput = (utcDate) => {
    const date = new Date(utcDate);
    const formattedDate = date.toISOString().split("T")[0];
    return formattedDate;
  };

  const handleChangeFinanciador = (e) => {
    const { name, value } = e.target;
    formik.handleChange(e);
    const selectedFinanciador = listFinanciadores.find(
      (financiador) => financiador.nroFinanciador === value
    );
    const nombreFinanciador = selectedFinanciador
      ? selectedFinanciador?.nombreFinanciador
      : "";
    formik.setFieldValue("nombreFinanciador", nombreFinanciador);
  };

  const handleGenerarReceta = async (patient) => {
    //const idMedico = localStorage.getItem("idMedico");
    const currentLocation = location.pathname;
  
    const data = {
      idMedico: idMedico,
      nombre: patient.nombre,
      apellido: patient.apellido,
      tipoDocumento: patient.tipoDocumento,
      nroDocumento: patient.nroDocumento,
      fechaNacimiento: patient.fechaNacimiento,
      email: patient.email,
      telefono: patient.telefono,
      sexo: patient.sexo,
      nombreFinanciador: patient.nombreFinanciador,
      nroFinanciador: patient.nroFinanciador,
      nroAfiliado: patient.nroAfiliado,
      plan: patient.plan,
      urlCallback: currentLocation,
    };
  
    try {
      const response = await integraBoton(data);
  
      if (response.statusResult === 200) {
        //window.open(response.result.url, "_blank");
        window.location.href = response.result.url;
      } else {
        if (Array.isArray(response.errors) && response.errors.length > 0) {
          enqueueSnackbar(response.errors[0], { variant: "error" });
        } else {
          enqueueSnackbar("Ocurrió un error desconocido", { variant: "error" });
        }
      }
    } catch (error) {
      console.error("Error en el servicio integraBoton:", error);
      enqueueSnackbar("Ocurrió un error en el servicio", { variant: "error" });
    }
  };

  // const handleGenerarReceta = async (patient) => {
  //   const idMedico = localStorage.getItem("idMedico");
  //   const currentLocation = location.pathname;

  //   const data = {
  //     idMedico: idMedico,
  //     nombre: patient.nombre,
  //     apellido: patient.apellido,
  //     tipoDocumento: patient.tipoDocumento,
  //     nroDocumento: patient.nroDocumento,
  //     fechaNacimiento: patient.fechaNacimiento,
  //     email: patient.email,
  //     telefono: patient.telefono,
  //     sexo: patient.sexo,
  //     nombreFinanciador: patient.nombreFinanciador,
  //     nroFinanciador: patient.nroFinanciador,
  //     nroAfiliado: patient.nroAfiliado,
  //     plan: patient.plan,
  //     urlCallback: currentLocation,
  //   };

  //   try {
  //     const res = await integraBoton(data);

  //     if (res.status === "Ok") {
  //       //window.open(res.result.url);
  //       window.location.href = res.result.url;
  //       return "Ok";
  //     } else {
  //       return res.errors.join(", ");
  //       //alert(res.errors.join(", "));
  //     }
  //   } catch (error) {
  //     //alert("Error al llamar a la función integraBoton:", error);
  //     return error;
  //   }
  // };

  return (
    <form onSubmit={formik.handleSubmit}>
      {/* Card de paciente */}
      <Card
        style={{
          border: "1px solid #ddd",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "8px",
        }}
      >
        <CardHeader
          title="Formulario de receta"
          subheader="Información para generar nueva receta para el paciente"
        />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                name="nombre"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.nombre}
                {...formik.getFieldProps("nombre")}
                error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                helperText={formik.touched.nombre && formik.errors.nombre}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Apellido"
                name="apellido"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.apellido}
                {...formik.getFieldProps("apellido")}
                error={
                  formik.touched.apellido && Boolean(formik.errors.apellido)
                }
                helperText={formik.touched.apellido && formik.errors.apellido}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.email}
                {...formik.getFieldProps("email")}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>

            <Grid item md={4} xs={12}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ my: 0, marginBottom: 0 }}
              >
                <InputLabel
                  htmlFor="tipoDocumento"
                  sx={{
                    color:
                      formik.touched.tipoDocumento &&
                      Boolean(formik.errors.tipoDocumento)
                        ? theme.palette.error.main
                        : "text.primary",
                  }}
                >
                  Tipo de Documento
                </InputLabel>
                <Select
                  native
                  label="Tipo de Documento"
                  inputProps={{
                    name: "tipoDocumento",
                    id: "tipoDocumento",
                  }}
                  sx={{
                    borderColor: formik.touched.tipoDocumento
                      ? Boolean(formik.errors.tipoDocumento)
                        ? theme.palette.error.main
                        : theme.palette.primary.main
                      : "rgba(0, 0, 0, 0.23)",
                    color: "text.primary",
                  }}
                  onChange={formik.handleChange}
                  value={formik.values.tipoDocumento}
                  error={
                    formik.touched.tipoDocumento &&
                    Boolean(formik.errors.tipoDocumento)
                  }
                >
                  <option value=""></option>
                  {listTipoDocumento.map((item) => (
                    <option key={item.valor} value={item.valor}>
                      {item.etiqueta}
                    </option>
                  ))}
                </Select>
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {formik.touched.tipoDocumento && formik.errors.tipoDocumento}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Nro de documento"
                name="nroDocumento"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.nroDocumento}
                {...formik.getFieldProps("nroDocumento")}
                error={
                  formik.touched.nroDocumento &&
                  Boolean(formik.errors.nroDocumento)
                }
                helperText={
                  formik.touched.nroDocumento && formik.errors.nroDocumento
                }
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Teléfono"
                name="telefono"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.telefono}
                {...formik.getFieldProps("telefono")}
                error={
                  formik.touched.telefono && Boolean(formik.errors.telefono)
                }
                helperText={formik.touched.telefono && formik.errors.telefono}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                label="Fecha de nacimiento"
                name="fechaNacimiento"
                variant="outlined"
                type="date"
                InputLabelProps={{ shrink: true }}
                onChange={formik.handleChange}
                value={formik.values.fechaNacimiento}
                {...formik.getFieldProps("fechaNacimiento")}
                error={
                  formik.touched.fechaNacimiento &&
                  Boolean(formik.errors.fechaNacimiento)
                }
                helperText={
                  formik.touched.fechaNacimiento &&
                  formik.errors.fechaNacimiento
                }
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{ my: 0, marginBottom: 2 }}
              >
                <InputLabel
                  htmlFor="sexo"
                  sx={{
                    color:
                      formik.touched.sexo && Boolean(formik.errors.sexo)
                        ? theme.palette.error.main
                        : "text.primary",
                  }}
                >
                  Sexo
                </InputLabel>
                <Select
                  native
                  label="Sexo"
                  inputProps={{
                    name: "sexo",
                    id: "sexo",
                  }}
                  sx={{
                    borderColor: formik.touched.sexo
                      ? Boolean(formik.errors.sexo)
                        ? theme.palette.error.main
                        : theme.palette.primary.main
                      : "rgba(0, 0, 0, 0.23)",
                    color: "text.primary",
                  }}
                  onChange={formik.handleChange}
                  value={formik.values.sexo}
                  error={formik.touched.sexo && Boolean(formik.errors.sexo)}
                >
                  <option value=""></option>
                  {listSexo.map((item) => (
                    <option key={item.valor} value={item.valor}>
                      {item.etiqueta}
                    </option>
                  ))}
                </Select>
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {formik.touched.sexo && formik.errors.sexo}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item md={3} xs={12}></Grid>

            {/* Acá vamos a poner los datos del financiador */}
            <Grid item md={4} xs={12} style={{ paddingTop: 0 }}>
              <FormControl fullWidth variant="outlined">
                <InputLabel
                  htmlFor="nroFinanciador"
                  sx={{
                    color:
                      formik.touched.nroFinanciador &&
                      Boolean(formik.errors.nroFinanciador)
                        ? theme.palette.error.main
                        : "text.primary",
                  }}
                >
                  Financiador
                </InputLabel>
                <Select
                  native
                  label="Financiador"
                  inputProps={{
                    name: "nroFinanciador",
                    id: "nroFinanciador",
                  }}
                  sx={{
                    borderColor: formik.touched.nroFinanciador
                      ? Boolean(formik.errors.nroFinanciador)
                        ? theme.palette.error.main
                        : theme.palette.primary.main
                      : "rgba(0, 0, 0, 0.23)",
                    color: "text.primary",
                  }}
                  onChange={(e) => {
                    handleChangeFinanciador(e);
                    formik.setFieldTouched("nroFinanciador", false);
                  }}
                  value={formik.values.nroFinanciador}
                  error={
                    formik.touched.nroFinanciador &&
                    Boolean(formik.errors.nroFinanciador)
                  }
                >
                  <option value=""></option>
                  {listFinanciadores.map((item) => (
                    <option
                      key={item.nroFinanciador}
                      value={item.nroFinanciador}
                    >
                      {item.nombreFinanciador}
                    </option>
                  ))}
                </Select>
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {formik.touched.nroFinanciador &&
                    formik.errors.nroFinanciador}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item md={4} xs={12} style={{ paddingTop: 0 }}>
              <TextField
                fullWidth
                label="Plan"
                name="plan"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.plan}
                {...formik.getFieldProps("plan")}
                error={formik.touched.plan && Boolean(formik.errors.plan)}
                helperText={formik.touched.plan && formik.errors.plan}
              />
            </Grid>
            <Grid item md={4} xs={12} style={{ paddingTop: 0 }}>
              <TextField
                fullWidth
                label="Nro Afiliado"
                name="nroAfiliado"
                variant="outlined"
                onChange={formik.handleChange}
                value={formik.values.nroAfiliado}
                {...formik.getFieldProps("nroAfiliado")}
                error={
                  formik.touched.nroAfiliado &&
                  Boolean(formik.errors.nroAfiliado)
                }
                helperText={
                  formik.touched.nroAfiliado && formik.errors.nroAfiliado
                }
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
            }}
          >
            {errorMessage && (
              <Stack sx={{ width: "auto", ml: "auto" }} spacing={2}>
                <Alert fullWidth severity="error">
                  {errorMessage}
                </Alert>
              </Stack>
            )}
            <LoadingButton
              loading={loading}
              color="primary"
              size="large"
              type="submit"
              variant="contained"
              sx={{ ml: 2 }}
            >
              Generar receta
            </LoadingButton>
          </Box>
        </CardActions>
      </Card>
    </form>
  );
};
